module.exports = __webpack_public_path__ + "media/images/calendar-icon-731a0a074b2d5f08f3545fa33e4fdcdd.svg";